import React from 'react'
import { LoginForm } from '../../components/authentication/login/LoginForm'
import styles from './login.module.css'
export function Login() {
    return (
        <div className={styles.container}>
            <LoginForm />
        </div>
    )
}
